import { PanelType } from '@fluentui/react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataDocument } from '../../data/DataDocument.jsx';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxDocumentLotCategorie } from '../ComboBox/ComboBoxDocumentLotCategorie.jsx';
import { ComboBoxDocumentLotType } from '../ComboBox/ComboBoxDocumentLotType.jsx';
import { ComboBoxDocumentOperationCategorie } from '../ComboBox/ComboBoxDocumentOperationCategorie.jsx';
import { ComboBoxDocumentOperationType } from '../ComboBox/ComboBoxDocumentOperationType.jsx';
import { ComboBoxDocumentReservationCategorie } from '../ComboBox/ComboBoxDocumentReservationCategorie.jsx';
import { ComboBoxDocumentReservationType } from '../ComboBox/ComboBoxDocumentReservationType.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox.jsx';
import { EUIPanel } from '../EUI/EUIPanel.jsx';
import { EUIToggle } from '../EUI/EUIToggle.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { PickerNumber } from '../Picker/PickerNumber.jsx';

export class FicheTelechargementDocuments extends Component {

    static defaultProps = {
        isOpen: false,
        /* --- */
        onDismiss: () => null,
    };

    static defaultState = {
        idDocumentLotCategorie: undefined,
        idDocumentLotType: undefined,
        idDocumentOperationCategorie: undefined,
        idDocumentOperationType: undefined,
        idDocumentReservationCategorie: undefined,
        idDocumentReservationType: undefined,
        idsOperations: [],
        labelType: undefined,
        mergeZipFiles: true,
        perimetre: "Operation",
        /* --- */
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheTelechargementDocuments.defaultState };
    };

    _onOpen = () => {
        this.setState({ ...FicheTelechargementDocuments.defaultState });
    };

    _onValidate = async () => {

        const { perimetre, idsOperations, idDocumentOperationType, idDocumentReservationType, idDocumentLotType, labelType, mergeZipFiles } = this.state;

        if (!mergeZipFiles || idsOperations.length === 1) {
            for (const [index, idOperation] of idsOperations.entries()) {

                this.setState({
                    enCoursDeTraitement: true,
                    messageEnCoursTraitement: `Téléchargement des documents de l'opération #${idOperation} ~ ${idsOperations.length - index} opération(s) restante(s)...`
                });

                const responseFetch = await DataDocument._onTelechargementDocuments(perimetre, [idOperation], idDocumentOperationType, idDocumentReservationType, idDocumentLotType);
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const fileData = responseFetch.reponseAPIobjet || [];
                    const file = Scriba.fichier().Base64VersByteArray(fileData);
                    const fileName = `${idOperation}-${labelType}-${perimetre}-${Date.now()}.zip`;
                    Scriba.fichier().EnregisterSous(file, fileName);
                    if (index === idsOperations.length - 1)
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);

            };
        }
        else {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Téléchargement en cours..."
            });

            DataDocument._onTelechargementDocuments(perimetre, idsOperations, idDocumentOperationType, idDocumentReservationType, idDocumentLotType).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const fileData = responseFetch.reponseAPIobjet || [];
                    const file = Scriba.fichier().Base64VersByteArray(fileData);
                    const fileName = `merged-${labelType}-${perimetre}-${Date.now()}.zip`;
                    Scriba.fichier().EnregisterSous(file, fileName);
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

        }

    };

    _onVerificationFormulaire = () => {
        const { perimetre, idDocumentLotType, idDocumentOperationType, idDocumentReservationType, idsOperations } = this.state;

        let onActiveBoutonEnregistrer = true
        onActiveBoutonEnregistrer &= Array.isArray(idsOperations) && idsOperations.length > 0;
        switch (perimetre) {
            case "Operation": onActiveBoutonEnregistrer &= !!idDocumentOperationType; break;
            case "Reservation": onActiveBoutonEnregistrer &= !!idDocumentReservationType; break;
            case "Lot": onActiveBoutonEnregistrer &= !!idDocumentLotType; break;
        }

        this.setState({ onActiveBoutonEnregistrer });
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const {
            idDocumentLotCategorie, idDocumentLotType, idDocumentOperationCategorie, idDocumentOperationType, idDocumentReservationCategorie, idDocumentReservationType, idsOperations,
            mergeZipFiles, onActiveBoutonEnregistrer, perimetre
        } = this.state;

        return <EUIPanel
            headerText="Téléchargement de documents ~ Console"
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onValidate={this._onValidate}
            type={PanelType.medium}
        >

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <EUIComboBox
                label="Type"
                onChange={(event, option) => this.setState({ perimetre: option.key }, this._onVerificationFormulaire)}
                options={[
                    { key: "Operation", text: "Opération" },
                    { key: "Reservation", text: "Réservation" },
                    { key: "Lot", text: "Lot" }
                ]}
                required
                selectedKey={perimetre}
            />

            {perimetre === "Operation" &&
                <>
                    <ComboBoxDocumentOperationCategorie
                        onChange={(event, option) => this.setState({ idDocumentOperationCategorie: option.key }, this._onVerificationFormulaire)}
                        required
                        selectedKey={idDocumentOperationCategorie}
                    />
                    <ComboBoxDocumentOperationType
                        idDocumentOperationCategorie={idDocumentOperationCategorie}
                        onChange={(event, option, index, value, item) => this.setState(
                            {
                                idDocumentOperationCategorie: item.idDocumentOperationCategorie,
                                idDocumentOperationType: option.key,
                                labelType: item.typeDocument.replace(/[^a-zA-Z0-9]/g, "")
                            },
                            this._onVerificationFormulaire
                        )}
                        required
                        selectedKey={idDocumentOperationType}
                    />
                </>
            }

            {perimetre === "Reservation" &&
                <>
                    <ComboBoxDocumentReservationCategorie
                        onChange={(event, option) => this.setState({ idDocumentReservationCategorie: option.key }, this._onVerificationFormulaire)}
                        required
                        selectedKey={idDocumentReservationCategorie}
                    />
                    <ComboBoxDocumentReservationType
                        idDocumentReservationCategorie={idDocumentReservationCategorie}
                        onChange={(event, option, index, value, item) => this.setState(
                            {
                                idDocumentReservationCategorie: item.idDocumentReservationCategorie,
                                idDocumentReservationType: option.key,
                                labelType: item.typeDocument.replace(/[^a-zA-Z0-9]/g, "")
                            },
                            this._onVerificationFormulaire
                        )}
                        required
                        selectedKey={idDocumentReservationType}
                    />
                </>
            }

            {perimetre === "Lot" &&
                <>
                    <ComboBoxDocumentLotCategorie
                        onChange={(event, option) => this.setState({ idDocumentLotCategorie: option.key }, this._onVerificationFormulaire)}
                        required
                        selectedKey={idDocumentLotCategorie}
                    />
                    <ComboBoxDocumentLotType
                        idDocumentLotCategorie={idDocumentLotCategorie}
                        onChange={(event, option, index, value, item) => this.setState(
                            {
                                idDocumentLotCategorie: item.idDocumentLotCategorie,
                                idDocumentLotType: option.key,
                                labelType: item.typeDocument.replace(/[^a-zA-Z0-9]/g, "")
                            },
                            this._onVerificationFormulaire
                        )}
                        required
                        selectedKey={idDocumentLotType}
                    />
                </>
            }

            <EUIToggle
                checked={mergeZipFiles}
                label="Fusionner les fichiers zippés"
                onChange={(e, isChecked) => this.setState({ mergeZipFiles: isChecked }, this._onVerificationFormulaire)}
            />

            <PickerNumber
                label="Ids opérations (séparés par un point-virgule)"
                numbers={idsOperations}
                onChange={(ids) => this.setState({ idsOperations: ids }, this._onVerificationFormulaire)}
                required
            />

        </EUIPanel>;
    };

};